/**
 * Her kelimenin ilk harfini büyük yapar.
 * "berkay mert" → "Berkay Mert"
 * "AHMET yılmaz" → "Ahmet Yılmaz"
 */
export function capitalizeWords(value: string): string {
  return value
    .replace(/\s+/g, ' ')
    .split(' ')
    .map(word => {
      if (!word) return '';
      return word.charAt(0).toLocaleUpperCase('tr-TR') + word.slice(1).toLocaleLowerCase('tr-TR');
    })
    .join(' ');
}

/**
 * Sadece rakamları alır, maksimum uzunluğu sınırlar.
 * Telefon numaraları için: maxLength = 11
 */
export function digitsOnly(value: string, maxLength: number = 11): string {
  const digits = value.replace(/\D/g, '');
  return digits.slice(0, maxLength);
}